import { render, staticRenderFns } from "./UpdateSection.vue?vue&type=template&id=0c1855e0&scoped=true"
import script from "./UpdateSection.vue?vue&type=script&lang=js"
export * from "./UpdateSection.vue?vue&type=script&lang=js"
import style0 from "./UpdateSection.vue?vue&type=style&index=0&id=0c1855e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1855e0",
  null
  
)

export default component.exports